import { START_LOADING, STOP_LOADING, SUCCESS } from "../types/index.js";

const ChitRequestReducer = (
  state = {
    IsError: false,
    isSuccess: false,
    isLoading: undefined,
    data: { data: [{ transactionNo: "Loading" }] },
  },
  action
) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case STOP_LOADING:
      return { ...state, isLoading: false };
    case SUCCESS:
      return { ...state, IsError: false, isSuccess: true };
    default:
      return state;
  }
};
export default ChitRequestReducer;
